import * as types from 'constants/actionTypes';
import * as Rx from 'rxjs';
const {Observable} = Rx;
const {of, ajax} = Observable;
import * as actions from 'actions/transactionLoggingActions';
const apiUrls = require('constants/apiUrls');
import { wowCustomHeader } from '../utils/wowCustomHeadersUtils';
import { getAccessTokenFromState } from 'utils/userManager';

export const indirect = {
    call: (fn, ...args) => fn(...args)
};

export const api = {
    sendTransactionsLogs: (logs, store) => {

        const state = store.getState();
        const accessToken = getAccessTokenFromState(state);

        const wowHeaders = wowCustomHeader(state);

        const userId = state
            .getIn(['user', 'userId']);

        return ajax({
            url: apiUrls.TECH_SEND_TRANSACTION_LOGS_URL,
            method: 'POST',
            body: {
                billingSystem: 'n/a',
                userId: userId,
                payload: JSON.stringify(logs),
                accountNumber: 'n/a',
                workOrderNumber: 'n/a',
                transactionType: 'log_dump'
            },
            responseType: '',
            crossDomain: true,
            timeout: apiUrls.API_TIMEOUT,
            headers: {
                ...wowHeaders,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'authorization': 'Bearer ' + accessToken
            }
        });
    }

};

export const sendTransactionLogEpic = (action$, store, call = indirect.call) => action$
    .ofType(types.TRANSACTION_LOG_SEND_STARTED)
    .mergeMap(action => call(api.sendTransactionsLogs, action.logs, store).map(payload => {
        return (actions.transactionLogSendFinished(payload, action.logs));
    }).catch(error => of(actions.transactionLogSendFailed(error))));



// WEBPACK FOOTER //
// ./src/epics/transactionLogEpic.js